import Decimal from 'big.js';
export default class LocaleHelper {
    /**
     * Returns the i18n instance.
     */
    static getI18n() {
        return LocaleHelper.i18n;
    }
    /**
     * Sets the i18n instance.
     *
     * @param i18n
     */
    static setI18n(i18n) {
        LocaleHelper.i18n = i18n;
    }
    /**
     * Returns the supported locales.
     */
    static getSupportedLocales() {
        return LocaleHelper.supportedLocales;
    }
    /**
     * Sets the supported locales.
     *
     * @param locales
     */
    static setSupportedLocales(locales) {
        LocaleHelper.supportedLocales = locales;
    }
    /**
     * Returns the current locale.
     */
    static getLocale() {
        return LocaleHelper.i18n.locale;
    }
    /**
     * Returns the current fallback locale.
     */
    static getFallbackLocale() {
        return LocaleHelper.i18n.fallbackLocale.toString();
    }
    /**
     * Sets the current locale.
     *
     * @param locale
     * @param fallbackLocale
     */
    static setLocale(locale, fallbackLocale) {
        LocaleHelper.i18n.locale = locale;
        if (fallbackLocale) {
            LocaleHelper.i18n.fallbackLocale = fallbackLocale;
        }
    }
    /**
     * Returns a translation for the current locale.
     *
     * @param translations
     */
    static getTranslationForCurrentLocale(translations) {
        const locale = LocaleHelper.getLocale();
        const fallbackLocale = LocaleHelper.getFallbackLocale();
        if (typeof translations === 'object') {
            // Try current locale.
            if (translations[locale]) {
                return translations[locale];
            }
            // Try fallback locale.
            else if (translations[fallbackLocale]) {
                return translations[fallbackLocale];
            }
            // Try English.
            else if (translations.en) {
                return translations.en;
            }
            // Try first available locale.
            else if (Object.keys(translations).length > 0) {
                const firstLocale = Object.keys(translations)[0];
                return translations[firstLocale];
            }
            else {
                return null;
            }
        }
        else {
            return translations;
        }
    }
    /**
     * Formats a value into currency format
     *
     * @param value
     * @param dp
     * @returns
     */
    static formatCurrency(value, dp = 2, currency = 'GBP', locale = LocaleHelper.getLocale()) {
        // Convert strings
        if (typeof value === 'number' || typeof value === 'string') {
            value = new Decimal(value);
        }
        // Round to required decimal places
        value.round(dp);
        // Format into the desired locale
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            minimumFractionDigits: dp,
        });
        return formatter.format(value.toNumber());
    }
}
LocaleHelper.i18n = null;
LocaleHelper.supportedLocales = [];
//# sourceMappingURL=locale-helper.js.map